// =============================================================================
// PEDRA — src/main.tsx
// Ponto de entrada da aplicacao. Este e o UNICO arquivo que importa CSS:
// nenhum componente traz folha de estilo propria.
// =============================================================================

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './styles/theme.css';
import './styles/global.css';
import './components/app.css';
import './components/grid.css';
import './components/modal.css';
import './components/results.css';

import { App, applyTheme, resolveInitialTheme } from './App';

// O tema entra no <html> ANTES do primeiro desenho, para nao piscar branco em
// quem usa o tema escuro.
applyTheme(resolveInitialTheme());

const container = document.getElementById('root');
if (container === null) {
  throw new Error('Elemento #root não encontrado: verifique o index.html.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
